import React, { useEffect, useRef, useState } from "react";
import TextOnly from "../Components/StreamingComponents/TextOnly";
import BrandingCard from "../Components/StreamingComponents/BrandingCard";
import { useSelector, useDispatch } from 'react-redux';
import { cloneDeep } from "lodash";
import { conversationList, storeChat, lastConversation, apiError } from "../Services/Redux/Reducers/chatSlice";
import { addchat } from "../Services/ApiServices/chatServices";
import { isStreamingStarted, loader } from "../Services/Redux/Reducers/commonSlice";
import MultiCatTemplate from "../Components/MultiCatCardTemplate/MultiCatTemplate";
import ApplicationFeedback from "./ApplicationFeedback";
import { MessageHistoryProps } from "../Services/CommonServices/propTypes";
import ProductListingGrid from "../Components/StreamingComponents/ProductLisitingGrid";
import SingleLookTemplate from "../Components/StreamingComponents/SingleLookTemplate";
import ProductDetailPage from "../Components/StreamingComponents/ProductDetailPage";
import LikeAndDislike from "./LikeAndDislike";
import APIErrorHandling from "../Components/StreamingComponents/APIErrorHandling";
import NetworkError from "../Components/StreamingComponents/NetworkError";

function MessageHistory(props) {
  const typewritterdelay = process.env.TYPE_WRITER_DELAY || 5;
  const conList = useSelector((state) => state.chat.conversationList);
  const loading = useSelector((state) => state.common.isLoader);
  const dispatch = useDispatch();
  const isStore = useSelector((state) => state.chat.storeChat);
  const isStream = useSelector((state) => state.chat.isStream);
  const isApiError = useSelector((state) => state.chat.apiError);
  const feedBackModal = useSelector((state) => state.feedBack.appFeedBackModal);
  const [isMobile, setIsMobile] = useState(true);
  const [loadedImages, setLoadedImages] = useState({});
  const [imageReady, setImageReady] = useState({});
  const initialLoadTimerRef = useRef({});
  const streamingStarted = useSelector((state) => state.common.isStreamingStarted)
  const isStopTriggered = useSelector((state) => state.chat.isStopButtonTriggered)

  const handleImageLoad = (index, conId, componentId) => {
    setLoadedImages((prev) => ({
      ...prev,
      [conId]: {
        ...(prev[conId] || {}),
        [componentId]: true,
      },
    }));
    setupInitialImageDelay(index, conId);
  };
 
  const isImageVisible = (conId, componentId) => {
    return loadedImages[conId]?.[componentId] === true && imageReady[conId] === true;
  };
 
  const setupInitialImageDelay = (index, conId) => {
    const delayLoader = setTimeout(() => {
      if(index === conList.length-1 && loading) {
        dispatch(isStreamingStarted(false));
      }
    }, 2000);
    if (!initialLoadTimerRef.current[conId]) {
      initialLoadTimerRef.current[conId] = setTimeout(() => {
        setImageReady(prev => ({
          ...prev,
          [conId]: true
        }));
      }, 2000);
    }
    return() => clearTimeout(delayLoader);
  };
 
  useEffect(() => {
    return () => {
      Object.values(initialLoadTimerRef.current).forEach(timer => clearTimeout(timer));
    };
  }, []);
 
  const getBestImageUrl = (con, forDesktop = false) => {
    if (con.isSingleLook && con.response.outfitUrl) {
      return con.response.outfitUrl.split("?fmt=webp-alpha")[0] + "?$rl_4x5_pdp$&fmt=webp-alpha";
    }
    if (!forDesktop && con.backgroundImage) {
      return con.backgroundImage;
    }
    if (con.desktopbackgroundImage) {
      return con.desktopbackgroundImage;
    }
    return con.backgroundImage || "";
  };
 
  const storeMessage = (conHis) => {
    if (process.env.REACT_APP_APPLICATION_VERSION === "Microsoft") {
      return;
    }
    let convo = cloneDeep(conHis);
    let convoList = cloneDeep(conHis);
    let lastItem = convo.pop();
    if (
      lastItem.response.responseType === "TextOnly" ||
      lastItem.response.responseType === "BrandingInformation"
    ) {
      lastItem.backgroundImage = "";
      lastItem.desktopbackgroundImage = "";
    } else if (
      lastItem.response.responseType === "ProductListing" &&
      lastItem.isSingleLook
    ) {
      if (lastItem.response.outfitUrl) {
        lastItem.backgroundImage = lastItem.response.outfitUrl;
      }
    }
    const conIndex = convoList.findIndex(
      (element) => element.uid === lastItem.uid
    );
    if (isStream && lastItem.response.responseType !== "Error" && localStorage.getItem('storeChat') !== "false") {
      try {
        addchat(
          lastItem,
          (response) => {
            convoList[conIndex]["id"] = response.data.id;
            convoList[conIndex]["showLikeDislike"] = true;
            convoList[conIndex]["error"] = "";
            dispatch(conversationList(convoList));
          },
          (err) => {
            console.log(
              "An error occurred in Store message api call  in chat.",
              err.message
            );
            dispatch(loader(false));
            dispatch(apiError("An error occurred in Store message api call  in chat."));
          }
        );
      } catch (err) {
        dispatch(loader(false));
        dispatch(apiError("An error occurred in Store message api call  in chat."));
        console.log(
          "An error occurred Store message api call  in chat.",
          err.message
        );
      } finally {
        dispatch(storeChat(false));
        dispatch(lastConversation(""));
      }
    }
  };

  useEffect(() => {
    if(isStore) {
      let conHis = cloneDeep(conList);
      storeMessage(conHis);
    }
  }, [isStore]);
 
  // useEffect(() => {
  //   if (!isStopTriggered && !loading && isStore) {
  //     let conHis = cloneDeep(conList);
  //     storeMessage(conHis);
  //     dispatch(lastConversation(""));
  //     dispatch(storeChat(false));
  //   } else {
  //     dispatch(storeChat(false));
  //   }
  // }, [loading, isStore]);
 
  const handleValueChange = (childValue) => {
    props.onValueChange(childValue);
  };
 
  useEffect(() => {
    if (window.innerWidth > 576) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  }, [window.innerWidth]);

  useEffect(() => {
    let historyLength = conList.length-1;
    let historyLength2 = conList.length-2;

    const chatInstancePrevious = document.getElementById('chatInstance'+historyLength2);
    if(chatInstancePrevious){
      chatInstancePrevious.style.minHeight = 'auto';
    }
    const chatInstanceLatest = document.getElementById('chatInstance'+historyLength);
     
    if(chatInstanceLatest){
      const isDetailView = conList[historyLength]?.response?.responseType === "ProductDetail" ||
            (conList[historyLength]?.response?.responseType === "ProductListing" &&
             conList[historyLength]?.isSingleLook === true);
      
      const shouldAutoScroll = isStream && !props.isScrolled && !isDetailView;
      
      if(shouldAutoScroll){       
        chatInstanceLatest.scrollIntoView({ behavior: "smooth", });
      }
      if (conList[historyLength].response.responseType === "ProductDetail") {
        chatInstanceLatest.style.minHeight = `calc((100vh - ${window.innerHeight * 0.02}px) - ${props.promptHeiht || 0}px  - 5px)`;
      }
      else {
        chatInstanceLatest.style.minHeight = `calc((100vh - ${65}px) - ${props.promptHeiht || 0}px)`;
      }
    }  
  }, [conList, props.promptHeiht]);

  return (
    <div className="messageHistory">
      {conList &&
        conList.map((con, index) => (
          <div id={"chatInstance"+index} key={"history" + index} className="chatInstance">
            <div
              className="col-11"
              style={{
                justifySelf: "flex-end",
                marginLeft: "auto",
                paddingTop: "40px",
                paddingBottom: "40px",
              }}
            >
              <div className={`chat_msg ms-auto me-3 me-sm-1 fadeOutPromts`}>
                <div className="d-flex align-items-start ps-0">
                  <span id="badge-text" className="badge-text">
                    {con.question}
                  </span>
                </div>
              </div>
            </div>
            <div>
              {/* <div className={`${((process.env.REACT_APP_NODE_ENV !== "uat" && process.env.REACT_APP_NODE_ENV !== "production") && con.uid === props.responseId) ? "session-id" : "session-id-none"}`}>
                Session Id: {props.sessionId}
              </div> */}
              { streamingStarted && conList.length - 1 === index && isStream && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div >

                      <img
                        src="/static/assets/InitialLoad.gif"
                        alt="dot"
                        className="loading-dots" />
                    </div>
                    <div
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div className="Commentdots" style={{ margin: 0 }}>
                        Let me think about that for a second{" "}
                      </div>
                      <div className="loading-dots dots">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            {(con.response.responseType ||
              con.response.responseText ||
              con.response.outfitUrl ||
              con.response.responseTitle ||
              con.response.branding ||
              con.response.products ||
              con.response.conclusion) && (
              <>
                {((con &&
                  con.response?.responseType &&
                  con.response?.responseType === "ProductListing") ||
                  (con &&
                    con.response?.responseType &&
                    con.response?.responseType === "ProductDetail")) && (
                  <div>
                    {/* header image for single look mobile view */}
                    <div className={`${!isMobile && "d-none"}`}>
                      {con?.isSingleLook ? (
                        <img
                          src={getBestImageUrl(con)}
                          alt="headerImg"
                          className={`${
                            con.response.outfitUrl
                              ? "outfitHeaderImg"
                              : "imgHeader"
                          } animate-header ${
                            isImageVisible(con.uid, "mobileBgHeader") ? "visible" : "invisible"
                          }`}
                          onLoad={() => handleImageLoad(index, con.uid, "mobileBgHeader")}
                        />
                      ) : (
                        <>
                          {con.backgroundImage !== "" ? (
                            <img
                              src={con.backgroundImage}
                              alt="headerImg"
                              className={`imgHeader animate-header ${
                                isImageVisible(con.uid, "mobileBgHeader")
                                  ? "visible"
                                  : "invisible"
                              }`}
                              onLoad={() =>
                                handleImageLoad(index,con.uid, "mobileBgHeader")
                              }
                            />
                          ) : (
                            <img
                              src={con.desktopbackgroundImage}
                              alt="headerImg"
                              className={`imgHeader animate-header ${
                                isImageVisible(con.uid, "mobileBgHeader")
                                  ? "visible"
                                  : "invisible"
                              }`}
                              onLoad={() =>
                                handleImageLoad(index, con.uid, "mobileBgHeader")
                              }
                            />
                          )
                          }
                        </>
                      )}
                    </div>
                    {/* header image for single look desktop view */}
                    <div className={`${isMobile && "d-none"}`}>
                      {con?.isSingleLook ? (
                        <img
                          src={getBestImageUrl(con, true)}
                          alt="headerImg"
                          className={`${
                            con.response.outfitUrl
                              ? "outfitHeaderImg-desktop"
                              : "imgHeader"
                          } ${
                            isImageVisible(con.uid, "desktopBgHeader") ? "visible" : "invisible"
                          }`}
                          onLoad={() =>
                            handleImageLoad(index, con.uid, "desktopBgHeader")
                          }
                        />
                      ) : (
                        con.desktopbackgroundImage && (
                          <img
                            src={con.desktopbackgroundImage}
                            alt="headerImg"
                            className={`imgHeader animate-header ${
                              isImageVisible(con.uid, "desktopBgHeader")
                                ? "visible"
                                : "invisible"
                            }`}
                            onLoad={() =>
                              handleImageLoad(index, con.uid, "desktopBgHeader")
                            }
                          />
                        )
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
            {Object.keys(con.response).length > 0 && (
              <div>
                {con &&
                  con.response?.responseType &&
                  con.response?.responseType === "NetworkError" && (
                  <NetworkError
                    convoId={con.uid}
                    index={index}
                    responseType={con.response.responseType}
                    text={con.response.responseText}
                    conclusion={''}
                    badIntentResponseCode={con.response.badIntentResponseCode || null}
                    responseStatusCode={con.response.responseStatusCode}
                    delay={typewritterdelay}
                    isAnswerComplete={props.isAnswerComplete}
                    stopClick={false}
                    onValueChange={handleValueChange}
                    effects={conList.length - 1 === index && isStream ? true : false}
                  />
                  )}
                  {con &&
                  con.response?.responseType &&
                  con.response?.responseType === "Error" && (
                  <APIErrorHandling
                    convoId={con.uid}
                    index={index}
                    responseType={con.response.responseType}
                    text={con.response.responseText}
                    conclusion={''}
                    badIntentResponseCode={con.response.badIntentResponseCode || null}
                    responseStatusCode={con.response.responseStatusCode}
                    delay={typewritterdelay}
                    isAnswerComplete={props.isAnswerComplete}
                    stopClick={false}
                    onValueChange={handleValueChange}
                    effects={conList.length - 1 === index && isStream ? true : false}
                  />
                  )}
                  {con &&
                  con.response?.responseType &&
                  con.response.badIntentResponseCode &&
                  con.response?.responseType === "TextOnly" && (
                  <TextOnly
                    convoId={con.uid}
                    index={index}
                    responseType={con.response.responseType}
                    text={con.response.responseText}
                    conclusion={con.response.responseConclusion}
                    badIntentResponseCode={con.response.badIntentResponseCode || null}
                    responseStatusCode={con.response.responseStatusCode}
                    delay={typewritterdelay}
                    isAnswerComplete={props.isAnswerComplete}
                    stopClick={false}
                    onValueChange={handleValueChange}
                    effects={conList.length - 1 === index && isStream ? true : false}
                  />
                  )}
                {con.response?.responseType !== "Error" && 
                  <div>
                    {con && con.response?.responseType && !con.response.badIntentResponseCode && con.response?.responseType === "TextOnly" && (
                      <TextOnly
                        convoId={con.uid}
                        index={index}
                        responseType={con.response.responseType}
                        text={con.response.responseText}
                        conclusion={con.response.responseConclusion}
                        delay={typewritterdelay}
                        isAnswerComplete={props.isAnswerComplete}
                        stopClick={false}
                        badIntentResponseCode={null}
                        responseStatusCode={con.response.responseStatusCode}
                        onValueChange={handleValueChange}
                        effects={
                          conList.length - 1 === index && isStream ? true : false
                        }
                        lookTitle={con.lookTitle}
                      />
                    )}
                    {con && con.response?.responseType && con.response?.responseType === "BrandingInformation" && (
                      <BrandingCard
                        convoId={con.uid}
                        index={index}
                        text={con.response.responseText}
                        branding={con.response.branding}
                        conclusion={con.response.responseConclusion}
                        delay={typewritterdelay}
                        isAnswerComplete={props.isAnswerComplete}
                        stopClick={false}
                        onValueChange={handleValueChange}
                        effects={
                          conList.length - 1 === index && isStream ? true : false
                        }
                        lookTitle={con.lookTitle}
                      />
                    )}
                    {con && con.response?.responseType && con.response?.responseType === "ProductListing" && con.isSingleLook && (
                      <div
                        className="single-look-container"
                        style={{ minHeight: "300px" }}
                      >
                        {isImageVisible(
                          con.uid,
                          isMobile ? "mobileBgHeader" : "desktopBgHeader"
                        ) ? (
                          <SingleLookTemplate
                            convoId={con.uid}
                            index={index}
                            responseTitle={con.response.responseTitle}
                            text={con.response.responseText}
                            outfitUrl={
                              con.response.outfitUrl || con.backgroundImage
                            }
                            branding={con.response.branding}
                            products={con.response.products}
                            conclusion={con.response.responseConclusion}
                            delay={typewritterdelay}
                            isAnswerComplete={props.isAnswerComplete}
                            stopClick={false}
                            onValueChange={handleValueChange}
                            effects={
                              conList.length - 1 === index && isStream
                                ? true
                                : false
                            }
                            lookTitle={con.lookTitle}
                          />
                        ) : (
                          <div
                            className="loading-placeholder"
                            style={{ height: "100%", width: "100%" }}
                          ></div>
                        )}
                      </div>
                    )}
                    {con && con.response?.responseType && con.response?.responseType === "ProductListing" && !con.isSingleLook && (
                      <div
                        className="product-listing-container"
                        style={{ minHeight: "300px" }}
                      >
                        {isImageVisible(
                          con.uid,
                          isMobile ? "mobileBgHeader" : "desktopBgHeader"
                        ) ? (
                          <ProductListingGrid
                            convoId={con.uid}
                            index={index}
                            responseTitle={con.response.responseTitle}
                            text={con.response.responseText}
                            outfitUrl={
                              con.response.outfitUrl || con.backgroundImage
                            }
                            branding={con.response.branding}
                            products={con.response.products}
                            conclusion={con.response.responseConclusion}
                            delay={typewritterdelay}
                            isAnswerComplete={props.isAnswerComplete}
                            stopClick={false}
                            onValueChange={handleValueChange}
                            effects={
                              conList.length - 1 === index && isStream
                                ? true
                                : false
                            }
                            lookTitle={con.lookTitle}
                          />
                        ) : (
                          <div
                            className="loading-placeholder"
                            style={{ height: "100%", width: "100%" }}
                          ></div>
                        )}
                      </div>
                    )}
                {con &&
                  con.response?.responseType === "ProductDetail" && (
                    <div
                      className="product-detail-container"
                      style={{ minHeight: "200px" }}
                    >
                      {isImageVisible(
                        con.uid,
                        isMobile ? "mobileBgHeader" : "desktopBgHeader"
                      ) ? (
                        <ProductDetailPage
                          convoId={con.uid}
                          index={index}
                          responseTitle={con.response.responseTitle}
                          text={con.response.responseText}
                          branding={con.response.branding}
                          product={con.response.products}
                          conclusion={con.response.responseConclusion}
                          delay={typewritterdelay}
                          isAnswerComplete={props.isAnswerComplete}
                          stopClick={false}
                          onValueChange={handleValueChange}
                          effects={
                            conList.length - 1 === index && isStream ? true : false
                          }
                          lookTitle={con.lookTitle}
                        />
                      ) : (
                        <div
                          className="loading-placeholder"
                          style={{ height: "100%", width: "100%" }}
                        ></div>
                      )}
                    </div>
                  )}
                  {con && con.response?.responseType === "ProductCollectionListing" && (
                    <div>
                      <MultiCatTemplate
                        convoId={con.uid}
                        index={index}
                        responseType={con.response.responseType}
                        responseTitle={con.response.responseTitle}
                        text={con.response.responseText}
                        branding={con.response.branding}
                        products={con.response.productCollections}
                        conclusion={con.response.responseConclusion}
                        delay={typewritterdelay}
                        isAnswerComplete={props.isAnswerComplete}
                        stopClick={false}
                        onValueChange={handleValueChange}
                        effects={
                          conList.length - 1 === index && isStream ? true : false
                        }
                        backgroundImage={con.backgroundImage}
                        desktopbackgroundImage={con.desktopbackgroundImage}
                        lookTitle={con.lookTitle}
                      />
                    </div>
                  )}
                </div>
              }
            </div>
          )}
          {
            con.response?.responseType !== "Error" && conList.length - 1 === index &&
            <div>
              {!isApiError && feedBackModal && <ApplicationFeedback />}
              {process.env.REACT_APP_APPLICATION_VERSION !== "Microsoft" && (!loading && !isApiError && !isStopTriggered) && 
                <div className="LikeNDislike">
                  <LikeAndDislike responseId={props.responseId} sessionChange={props.sessionChange} badIntentResponseCode={conList[conList.length - 1]?.response?.badIntentResponseCode} />
                </div>
              }
            </div>
          }
        </div>
      ))}
    </div>
  );
}
 
MessageHistory.propTypes = MessageHistoryProps;
 
export default MessageHistory;